<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title1">Sabotage</h1>
<h2 class="center" style="margin-top:60px;">Jimmy Coates, Book 4</h2>
<h3 class="center" style="margin-top:60px;">Joe Craig</h3>
<p class="center" style="margin-top:80px;"><img alt="" src="image/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?4b162790